import { handleToast } from '../modules/handleToast';

const copyButtons = document.querySelectorAll('.js-copy-button');
if (copyButtons.length > 0) {
    const copyFallback = text => {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
    };

    const handleButtonClick = async e => {
        try {
            const { currentTarget } = e;
            const url = currentTarget.getAttribute('data-url');
            const copyText = currentTarget.getAttribute('data-copy-text');

            if (navigator.clipboard && navigator.clipboard.writeText) {
                await navigator.clipboard.writeText(url);
            } else {
                copyFallback(url);
            }

            handleToast('success', copyText, 1500);
        } catch (error) {
            console.error(`Error: ${error.message}`);
        }
    };

    copyButtons.forEach(copyButton => {
        copyButton.addEventListener('click', handleButtonClick);
    });
}
